import { Alert } from '@/components/ui/Alert'
import { useToasts } from '@/lib/toast'

/**
 * Where toasts appear. Mounted once, at the root, so a message raised on a screen that
 * then navigates away still gets seen.
 *
 * The region is `aria-live="polite"`, which is what lets a screen reader announce a
 * confirmation without stealing focus mid-task. `Alert` marks an error toast `role="alert"`
 * of its own, so the urgent ones still interrupt.
 */
export function Toaster() {
  const toasts = useToasts((s) => s.toasts)
  const dismiss = useToasts((s) => s.dismiss)

  return (
    <div
      aria-live="polite"
      aria-label="Notifications"
      // `pointer-events-none` on the stack, restored on each toast: an empty toast area
      // must not swallow clicks on the page underneath it.
      className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col items-center gap-2 p-4 sm:inset-x-auto sm:right-0 sm:items-end"
    >
      {toasts.map((t) => (
        // The opaque backing is a wrapper rather than a class on the Alert: the tone tint
        // is a background too, and merging the two would just replace it.
        <div
          key={t.id}
          className="pointer-events-auto w-full max-w-sm rounded-md bg-white shadow-lg dark:bg-slate-900"
        >
          <Alert tone={t.tone} title={t.title} onDismiss={() => dismiss(t.id)}>
            {t.message}
          </Alert>
        </div>
      ))}
    </div>
  )
}
